module.exports = __webpack_public_path__ + "img/QOOKER_Box25.bd8bb818.jpg";